<template>

    <div v-if="Store.CheckoutHideUI == false">
        <div class="row" >

            <div class="col-12 col-md-7 order-2 order-md-1 shadow-sm" style="border:1px solid lightgray">

                <div class="row">
                    <div class="col-12 h5 mb-0 pt-3 pb-3" style="border-bottom: 1px solid lightgray; color: rgb(45, 194, 107);">
                        <i class="bi bi-credit-card"></i>&nbsp; Payment Details
                    </div>
                </div>
                <div class="mb-2"></div>

                <div v-if="!StripeFormLoaded" style="display: flex; justify-content: center; align-items: center; height: 150px; ">
                    <img style="width:100px;" src="/images/loading.gif" alt="Loading Image" />
                </div>

                <div id="payment-element">
                    <!-- Elements will create form elements here -->
                </div>

                <label v-if="PaymentError" caption class="mt-2 blink text-red" style="font-size:14px;">
                    <i name="bi bi-warning" style="top:-2px;"></i>&nbsp;{{PaymentError}}
                </label>

                <br v-if="!StripeFormClearToSubmit" />
                <label v-if="StripeFormLoaded && !StripeFormClearToSubmit" caption class="mt-2 text-red" style="font-size:12px;">Please Complete All Required Fields</label>
                <br v-if="!StripeFormClearToSubmit" />
                <button v-if="StripeFormLoaded"
                        class="btn btn-primary mt-4 shadow-sm mb-4"
                        type="button"
                        :disabled="!StripeFormClearToSubmit"
                        :title="!StripeFormClearToSubmit ? 'Please complete the payment form' : ''"
                        :style="!StripeFormClearToSubmit ? { cursor: 'not-allowed', pointerEvents: 'all' } : {}"
                        @click="OnPaymentSubmit">

                    <span>
                        Pay {{ TotalPriceAfterTax }}
                    </span>
                </button>
            </div>

            <div class="col-12 col-md-5 order-1 order-md-2 shadow-sm" style="border:1px solid lightgray">
                <div class="row">
                    <div class="col-12 h5 mb-0 pt-3 pb-3" style="border-bottom: 1px solid lightgray; color: rgb(45, 194, 107);">
                        <i class="bi bi-cart"></i>&nbsp; Your Cart
                    </div>
                </div>

                <!--RON Notarization-->
                <div class="q-mt-lg text-start" v-if="Store.Checkout.Cart.SelectedService == 'RONNotarization'">
                    <div class="mb-2"></div>
                    <div class="row">
                        <div class="col-12 p-0">
                            <ul class="list-group mb-3">
                                <li class="list-group-item d-flex justify-content-between lh-sm" style="border-top:none;">
                                    <div>
                                        <h6 class="my-0">Service Type</h6>
                                        <small class="text-muted">Remote Online Notarization</small> /
                                        <small v-if="(Store.Checkout.Cart.SelectedService == 'RONNotarization' && Store.Checkout.Cart.NotaryServiceType == 0)">
                                            General Notary Work
                                        </small>
                                        <small v-else>
                                            Loan Signing Package
                                        </small>
                                        <small class="text-muted" v-if="Store.Checkout.Cart.ServiceSpeed == 1">
                                            <br />
                                            <span class="text-primary"><i class="bi bi-check-circle"></i> Instant Online</span>
                                        </small>
                                    </div>
                                    <!--<span class="text-muted">$12</span>-->
                                </li>
                                <template v-if="(Store.Checkout.Cart.SelectedService == 'RONNotarization' && Store.Checkout.Cart.NotaryServiceType == 0)">
                                    <li class="list-group-item d-flex justify-content-between lh-sm">
                                        <div>
                                            <h6 class="my-0">Payment Information</h6>
                                            <small class="text-muted" v-if="this.Store.TenantConfig.serviceConfigNotary.notaryTechFee">
                                                At this time, you will be charged the platform fee of ${{this.Store.TenantConfig.serviceConfigNotary.notaryTechFee.toFixed(2)}}, which covers most notarizations.<br /><br />
                                                In the event that you require additional services, you will have an opportunity to review and approve those charges after the notarization is complete.
                                            </small>
                                        </div>
                                    </li>
                                    <li class="list-group-item d-flex justify-content-between lh-sm">
                                        <div>
                                            <h6 class="my-0">Platform/Technology Fee</h6>
                                            <small class="" style="color:blue;">${{this.Store.TenantConfig.serviceConfigNotary.notaryTechFee.toFixed(2)}} <span style="font-style:italic">(charged now)</span></small>
                                        </div>
                                    </li>
                                    <li class="list-group-item d-flex justify-content-between lh-sm">
                                        <div>
                                            <h6 class="my-0">Appointment Time</h6>
                                            <small class="text-muted" v-if="Store.Checkout.Cart.ServiceSpeed == 0 && Store.Checkout.Cart.ChosenAppointmentSlot">{{FormatDate(Store.Checkout.Cart.ChosenAppointmentSlot.StartTime)}}</small>
                                            <small class="text-muted" v-else-if="Store.Checkout.Cart.ServiceSpeed == 0">Appointment not selected</small>
                                            <small class="text-muted" v-else>Instant, Online, Now!</small>
                                        </div>
                                        <!--<span class="text-muted">$12</span>-->
                                    </li>
                                    <li class="list-group-item d-flex justify-content-between lh-sm">
                                        <div>
                                            <h6 class="my-0">Included Services</h6>
                                            <small class="text-muted" style="color:blue;">
                                                {{this.Store.TenantConfig.serviceConfigNotary.notarySealsIncluded}} X Notary seals
                                                <br />
                                                {{this.Store.TenantConfig.serviceConfigNotary.notarySignaturesIncluded}} X Notarized signatures
                                            </small>
                                        </div>
                                    </li>
                                    <li class="list-group-item d-flex justify-content-between lh-sm">
                                        <div>
                                            <h6 class="my-0">Possible Additional Fees <small style="font-size:12px" class="text-muted"><br />(if any, collected after notarization is complete)</small></h6>
                                            <br />
                                            <small class="text-muted" style="color:blue;">
                                                ${{this.Store.TenantConfig.serviceConfigNotary.notaryAdditionalSeals.toFixed(2)}} / additional Notary seal
                                                <br />
                                                ${{this.Store.TenantConfig.serviceConfigNotary.notaryAdditionalSignatures.toFixed(2)}} / additional signature notarized
                                                <br />
                                                ${{this.Store.TenantConfig.serviceConfigNotary.notaryAdditionalSigners.toFixed(2)}} / additional signer beyond 1st
                                            </small>
                                        </div>
                                    </li>

                                </template>
                                <li v-if="Store.Checkout.Cart.NotaryServiceType == 1" class="list-group-item d-flex justify-content-between lh-sm">
                                    <div>
                                        <h6 class="my-0">Appointment Time</h6>
                                        <small class="text-muted" v-if="Store.Checkout.Cart.ServiceSpeed == 0 && Store.Checkout.Cart.ChosenAppointmentSlot">{{FormatDate(Store.Checkout.Cart.ChosenAppointmentSlot.StartTime)}}</small>
                                        <small class="text-muted" v-else-if="Store.Checkout.Cart.ServiceSpeed == 0">Appointment not selected</small>
                                        <small class="text-muted" v-else>Instant, Online, Now!</small>
                                    </div>
                                    <!--<span class="text-muted">$12</span>-->
                                </li>
                                <li v-if="Store.Checkout.Cart.NotaryServiceType == 1" class="list-group-item d-flex justify-content-between lh-sm">
                                    <div>
                                        <h6 class="my-0 text-primary">Service Fee</h6>
                                        <small class="text-muted">Loan package flat fee</small>
                                    </div>
                                    <span class="text-muted">{{FormatAsMoney(Store.TenantConfig.serviceConfigNotary.notaryLoanClosingCost.toFixed(2))}}</span>
                                </li>

                                <li v-if="TaxAmount" class="list-group-item d-flex justify-content-between lh-sm">
                                    <div>
                                        <h6 class="my-0">Tax</h6>
                                    </div>
                                    <span class="text-muted">{{FormatAsMoney(TaxAmount)}}</span>
                                </li>
                                <li class="list-group-item d-flex justify-content-between lh-sm">
                                    <div>
                                        <h6 class="my-0 text-primary">Total Price</h6>
                                    </div>
                                    <span class="text-primary fw-bold">{{TotalPriceAfterTax}}</span>
                                </li>
                            </ul>
                        </div>


                    </div>
                </div>

                <!--Field Notarization-->
                <div class="q-mt-lg text-start" v-if="Store.Checkout.Cart.SelectedService == 'FieldNotarization'">
                    <div class="mb-2"></div>
                    <div class="row">
                        <div class="col-12 p-0">
                            <ul class="list-group mb-3">
                                <li class="list-group-item d-flex justify-content-between lh-sm" style="border-top:none;">
                                    <div>
                                        <h6 class="my-0">Service Type</h6>
                                        <small class="text-muted">Field Notarization</small>
                                    </div>
                                    <!--<span class="text-muted">$12</span>-->
                                </li>
                                <li v-if="Store.Checkout.Cart.NotaryServiceType == 0" class="list-group-item d-flex justify-content-between lh-sm">
                                    <div>
                                        <h6 class="my-0">Document Type</h6>
                                        <small class="text-muted">General Notary Work</small>
                                    </div>
                                </li>
                                <li v-if="Store.Checkout.Cart.NotaryServiceType == 1" class="list-group-item d-flex justify-content-between lh-sm">
                                    <div>
                                        <h6 class="my-0">Documentation Type</h6>
                                        <small class="text-muted">Loan Package</small>
                                    </div>
                                </li>
                                <li class="list-group-item d-flex justify-content-between lh-sm">
                                    <div>
                                        <h6 class="my-0">Meeting Location</h6>
                                        <small class="text-muted">{{Store.Checkout.Cart.StartAddress}}</small>
                                    </div>
                                </li>
                                <li class="list-group-item d-flex justify-content-between lh-sm">
                                    <div>
                                        <h6 class="my-0">Appointment Time</h6>
                                        <small class="text-muted">{{AppointmentDetails}}</small>
                                    </div>
                                </li>
                                <li v-if="Store.Checkout.Cart.NotaryServiceType == 0" class="list-group-item d-flex justify-content-between lh-sm">
                                    <div>
                                        <h6 class="my-0">Base Travel Fee</h6>
                                    </div>
                                    <span class="text-muted">{{FormatAsMoney(Store.TenantConfig.serviceConfigMobileNotary.travelCostBaseFee.toFixed(2))}}</span>
                                </li>
                                <li v-if="Store.Checkout.Cart.NotaryServiceType == 0" class="list-group-item d-flex justify-content-between lh-sm">
                                    <div>
                                        <h6 class="my-0">Mileage Fee</h6>
                                        <small class="text-muted">{{Store.Checkout.Cart.MapDistance}} miles (dispatch distance) * {{FormatAsMoney(Store.TenantConfig.serviceConfigMobileNotary.travelCostPerMile.toFixed(2))}}/mile</small>
                                    </div>
                                    <span class="text-muted">{{FormatAsMoney(Store.Checkout.Cart.Price - Store.TenantConfig.serviceConfigMobileNotary.travelCostBaseFee)}}</span>
                                </li>
                                <li v-if="Store.Checkout.Cart.NotaryServiceType == 1" class="list-group-item d-flex justify-content-between lh-sm">
                                    <div>
                                        <h6 class="my-0">Service Fee</h6>
                                        <small class="text-muted">Loan package flat fee</small>
                                    </div>
                                    <span class="text-muted">{{FormatAsMoney(Store.TenantConfig.serviceConfigMobileNotary.notaryLoanClosingCost.toFixed(2))}}</span>
                                </li>

                                <li v-if="TaxAmount" class="list-group-item d-flex justify-content-between lh-sm">
                                    <div>
                                        <h6 class="my-0 text-primary">Price</h6>
                                    </div>
                                    <span class="">{{FormatAsMoney(Store.Checkout.Cart.Price)}}</span>
                                </li>

                                <li v-if="TaxAmount" class="list-group-item d-flex justify-content-between lh-sm">
                                    <div>
                                        <h6 class="my-0">Tax</h6>
                                    </div>
                                    <span class="text-muted">{{FormatAsMoney(TaxAmount)}}</span>
                                </li>
                                <li class="list-group-item d-flex justify-content-between lh-sm">
                                    <div>
                                        <h6 class="my-0 text-primary">Total Price</h6>
                                    </div>
                                    <span class="text-primary fw-bold">{{TotalPriceAfterTax}}</span>
                                </li>
                            </ul>
                        </div>


                    </div>
                </div>

                <!--Courier Delivery-->
                <div class="q-mt-lg text-start" v-if="Store.Checkout.Cart.SelectedService == 'CourierDelivery'">
                    <div class="mb-2"></div>
                    <div class="row">
                        <div class="col-12 p-0">
                            <ul class="list-group mb-3">
                                <li class="list-group-item d-flex justify-content-between lh-sm" style="border-top:none;">
                                    <div>
                                        <h6 class="my-0">Service Type</h6>
                                        <small class="text-muted">Courier Delivery</small>
                                    </div>
                                    <!--<span class="text-muted">$12</span>-->
                                </li>
                                <li class="list-group-item d-flex justify-content-between lh-sm">
                                    <div>
                                        <h6 class="my-0">Pick-Up Location</h6>
                                        <small class="text-muted">{{Store.Checkout.Cart.StartAddress}}</small>
                                    </div>
                                    <!--<span class="text-muted">$12</span>-->
                                </li>

                                <li class="list-group-item d-flex justify-content-between lh-sm" v-if="Store.Checkout.Cart.ChosenAppointmentSlot">
                                    <div>
                                        <h6 class="my-0">Pick-Up Time</h6>
                                        <small class="text-muted">{{FormatDate(Store.Checkout.Cart.ChosenAppointmentSlot.StartTime)}}</small>
                                    </div>
                                    <!--<span class="text-muted">$12</span>-->
                                </li>
                                <li v-if="Store.Checkout.Cart.CourierPickupFee" class="list-group-item d-flex justify-content-between lh-sm">
                                    <div>
                                        <h6 class="my-0">Pick-Up Fee</h6>
                                    </div>
                                    <span class="text-muted">{{FormatAsMoney(Store.Checkout.Cart.CourierPickupFee)}}</span>
                                </li>
                                <li v-for="(item, idx) in Store.Checkout.Cart.DeliveryItemInfo" class="list-group-item d-flex justify-content-between lh-sm">
                                    <div>
                                        <h6 class="my-0">Delivery Item #{{idx+1}}</h6>
                                        <span class="text-primary fst-italic" style="font-size:12px;" v-if="item.Express"><i class="bi bi-lightning"> Express Service</i></span>
                                        <br v-if="item.Express" />
                                        <small class="text-muted fw-bold" style="font-size:12px;" v-if="FormatCourierRecipient(item)"><span class="fw-bold"><i class="bi bi-person"></i></span> {{FormatCourierRecipient(item)}}</small>
                                        <br v-if="FormatCourierRecipient(item)" />
                                        <small class="fst-italic text-info" style="font-size:12px;"><span class="fw-bold"><i class="bi bi-geo-alt"></i></span>{{FormatCourierAddress(item)}}</small>
                                        <small class="text-muted fst-italic" style="font-size:10px;" v-if="FormatCourierInstructions(item.Instructions)"><br /><span class="fw-bold"><i class="bi bi-pencil"></i></span> {{FormatCourierInstructions(item.Instructions)}}</small>

                                    </div>
                                    <span class="text-muted fw-bold" v-if="item.Express">{{FormatAsMoney(item.CostExpress)}}</span>
                                    <span class="text-muted fw-bold" v-if="!item.Express">{{FormatAsMoney(item.Cost)}}</span>
                                </li>
                                <li class="list-group-item d-flex justify-content-between lh-sm">
                                    <div class="">
                                        <h6 class="my-0 text-info">Delivery Terms</h6>
                                        <span @click="ViewCourierTerms(Store.TenantConfig.serviceConfigCourier.expressDeliveryTerms)" v-if="HaveExpressCourierItems" class="" style="font-size:12px;cursor:pointer"><i class="bi bi-lightning fw-bold text-decoration-underline"> Express Service Terms</i></span>
                                        <br />
                                        <span @click="ViewCourierTerms(Store.TenantConfig.serviceConfigCourier.standardDeliveryTerms)" v-if="HaveStandardCourierItems" class="" style="font-size: 12px; cursor: pointer"><i class="bi bi-truck-flatbed fw-bold text-decoration-underline"> Standard Service Terms</i></span>
                                    </div>
                                </li>
                                <li v-if="TaxAmount" class="list-group-item d-flex justify-content-between lh-sm">
                                    <div>
                                        <h6 class="my-0">Price</h6>
                                    </div>
                                    <span class="">{{FormatAsMoney(Store.Checkout.Cart.Price)}}</span>
                                </li>
                                <li v-if="TaxAmount" class="list-group-item d-flex justify-content-between lh-sm">
                                    <div>
                                        <h6 class="my-0">Tax</h6>
                                    </div>
                                    <span class="text-muted">{{FormatAsMoney(TaxAmount)}}</span>
                                </li>
                                <li class="list-group-item d-flex justify-content-between lh-sm">
                                    <div>
                                        <h6 class="my-0 text-primary">Total Price</h6>
                                    </div>
                                    <span class="text-primary fw-bold">{{TotalPriceAfterTax}}</span>
                                </li>


                            </ul>
                        </div>
                    </div>



                </div>

                <!--Apostille-->
                <div class="q-mt-lg text-start" v-if="Store.Checkout.Cart.SelectedService == 'Apostille'">
                    <div class="mb-2"></div>
                    <div class="row">
                        <div class="col-12 p-0">
                            <ul class="list-group mb-3">
                                <li class="list-group-item d-flex justify-content-between lh-sm" style="border-top:none;">
                                    <div>
                                        <h6 class="my-0">Service Type</h6>
                                        <small class="text-muted">Apostille Service</small>
                                    </div>
                                    <!--<span class="text-muted">$12</span>-->
                                </li>
                                <li class="list-group-item d-flex justify-content-between lh-sm">
                                    <div>
                                        <h6 class="my-0">Number Of Documents</h6>
                                        <small class="text-muted">{{Store.Checkout.Cart.NumApostilleItems}}</small>
                                    </div>
                                    <!--<span class="text-muted">$12</span>-->
                                </li>
                                <li class="list-group-item d-flex justify-content-between lh-sm">
                                    <div>
                                        <h6 class="my-0">Document Return Address</h6>
                                        <small class="text-muted" v-html="FormatApostilleRetAddr(Store.Checkout.Cart.ApostilleReturn)"></small>
                                    </div>
                                    <!--<span class="text-muted">$12</span>-->
                                </li>
                                <li class="list-group-item d-flex justify-content-between lh-sm">
                                    <div>
                                        <h6 class="my-0">Service Speed</h6>
                                        <small class="text-muted" v-if="Store.Checkout.Cart.ServiceSpeed == 0">Standard Service</small>
                                        <small class="text-muted" v-if="Store.Checkout.Cart.ServiceSpeed == 1">Express Service</small>
                                    </div>
                                    <!--<span class="text-muted">$12</span>-->
                                </li>
                                <li class="list-group-item d-flex justify-content-between lh-sm">
                                    <div>
                                        <h6 class="my-0">Service Terms</h6>
                                        <small class="text-muted" v-if="Store.Checkout.Cart.ServiceSpeed == 0">{{Store.TenantConfig.serviceConfigApostille.standardDeliveryTerms}}</small>
                                        <small class="text-muted" v-if="Store.Checkout.Cart.ServiceSpeed == 1">{{Store.TenantConfig.serviceConfigApostille.expressDeliveryTerms}}</small>
                                    </div>
                                    <!--<span class="text-muted">$12</span>-->
                                </li>

                                <li v-if="TaxAmount" class="list-group-item d-flex justify-content-between lh-sm">
                                    <div>
                                        <h6 class="my-0">Price</h6>
                                    </div>
                                    <span class="">{{FormatAsMoney(Store.Checkout.Cart.Price)}}</span>
                                </li>
                                <li v-if="TaxAmount" class="list-group-item d-flex justify-content-between lh-sm">
                                    <div>
                                        <h6 class="my-0">Tax</h6>
                                    </div>
                                    <span class="text-muted">{{FormatAsMoney(TaxAmount)}}</span>
                                </li>
                                <li class="list-group-item d-flex justify-content-between lh-sm">
                                    <div>
                                        <h6 class="my-0 text-primary">Total Price</h6>
                                    </div>
                                    <span class="text-primary fw-bold">{{TotalPriceAfterTax}}</span>
                                </li>


                            </ul>
                        </div>
                    </div>



                </div>

                <!--Field Inspection-->
                <div class="q-mt-lg text-start" v-if="Store.Checkout.Cart.SelectedService == 'FieldInspection'">
                    <div class="mb-2"></div>
                    <div class="row">
                        <div class="col-12 p-0">
                            <ul class="list-group mb-3">
                                <li class="list-group-item d-flex justify-content-between lh-sm" style="border-top:none;">
                                    <div>
                                        <h6 class="my-0">Service Type</h6>
                                        <small class="text-muted">Field Inspection</small>
                                    </div>
                                    <!--<span class="text-muted">$12</span>-->
                                </li>
                                <li class="list-group-item d-flex justify-content-between lh-sm">
                                    <div>
                                        <h6 class="my-0">Inspection Address</h6>
                                        <small class="text-muted">{{Store.Checkout.Cart.StartAddress}}</small>
                                    </div>
                                    <!--<span class="text-muted">$12</span>-->
                                </li>
                                <li class="list-group-item d-flex justify-content-between lh-sm" v-if="Store.Checkout.Cart.ChosenAppointmentSlot">
                                    <div>
                                        <h6 class="my-0">Inspection Time</h6>
                                        <small class="text-muted">{{FormatDate(Store.Checkout.Cart.ChosenAppointmentSlot.StartTime)}}</small>
                                    </div>
                                    <!--<span class="text-muted">$12</span>-->
                                </li>
                                <li class="list-group-item d-flex justify-content-between lh-sm">
                                    <div>
                                        <h6 class="my-0">Location Type</h6>
                                        <small class="text-muted">{{Store.Checkout.Cart.InspectionLocationType}} <span v-if="Store.Checkout.Cart.InspectionLocationType == 'Residential'"></span>({{Store.Checkout.Cart.InspectionOccupiedType}})</small>
                                    </div>
                                    <!--<span class="text-muted">$12</span>-->
                                </li>

                                <li class="list-group-item d-flex justify-content-between lh-sm">
                                    <div>
                                        <h6 class="my-0">Report Type</h6>
                                        <small class="text-muted" v-if="Store.Checkout.Cart.InspectionReportType == 'Photo'">HD Photography</small>
                                        <small class="text-muted" v-if="Store.Checkout.Cart.InspectionReportType == 'ChecklistOnly'">Written Checklist Only</small>
                                        <small class="text-muted" v-if="Store.Checkout.Cart.InspectionReportType == 'Video'">HD Video</small>
                                        <small class="text-muted" v-if="Store.Checkout.Cart.InspectionReportType == 'LiveStream'">Live Streaming</small>
                                    </div>
                                    <!--<span class="text-muted">$12</span>-->
                                </li>
                                <li class="list-group-item d-flex justify-content-between lh-sm">
                                    <div>
                                        <h6 class="my-0">Checklist Items</h6>

                                        <ul style="list-style:none;padding-left:5px;">
                                            <template v-for="itm in Store.Checkout.Cart.InspectionCheckList">
                                                <li v-if="itm.val">
                                                    <small class="text-muted">- {{itm.val}}</small>
                                                </li>
                                            </template>
                                        </ul>

                                    </div>
                                    <!--<span class="text-muted">$12</span>-->
                                </li>

                                <li v-if="TaxAmount" class="list-group-item d-flex justify-content-between lh-sm">
                                    <div>
                                        <h6 class="my-0">Price</h6>
                                    </div>
                                    <span class="">{{FormatAsMoney(Store.Checkout.Cart.Price)}}</span>
                                </li>
                                <li v-if="TaxAmount" class="list-group-item d-flex justify-content-between lh-sm">
                                    <div>
                                        <h6 class="my-0">Tax</h6>
                                    </div>
                                    <span class="text-muted">{{FormatAsMoney(TaxAmount)}}</span>
                                </li>
                                <li class="list-group-item d-flex justify-content-between lh-sm">
                                    <div>
                                        <h6 class="my-0 text-primary">Total Price</h6>
                                    </div>
                                    <span class="text-primary fw-bold">{{TotalPriceAfterTax}}</span>
                                </li>


                            </ul>
                        </div>
                    </div>



                </div>

            </div>


        </div>


    </div>
    <div style="z-index:300" class="modal fade" id="OrderCompleteModal" tabindex="-1" aria-labelledby="OrderCompleteModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog modal-dialog-centered" style="min-width:350px;max-width:500px;">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="d-flex align-items-center">
                        <i class="bi bi-check-circle-fill text-success" style="font-size:2rem;margin-right:10px;"></i>
                        <h5 class="modal-title" id="OrderCompleteModalLabel">Order Complete</h5>
                    </div>                    
                </div>
                <div class="modal-body">
                    <div v-if="WasInstantRONOrder">
                        <p>Thank you for your order!<br/>Please proceed to the online meeting room now.</p>
                        
                    </div>
                    <div v-else>
                        <p>Thank you for your business!<br/>We have emailed a receipt to your inbox.</p>
                    </div>
                </div>
                <div class="modal-footer">
                    <a v-if="WasInstantRONOrder" :href="AfterOrderCompleteUrl" target="_blank" class="btn btn-primary w-100 mb-2">Go to Notary Session Room</a>
                    <a v-else :href="AfterOrderCompleteUrl" class="btn btn-primary w-100 mb-2">View My Orders</a>
                </div>
            </div>
        </div>
    </div>
    <div data-bs-keyboard="false" style="z-index:300;" id="MessageModalCourierTerms" class="modal" tabindex="-1" role="dialog" aria-labelledby="Modal Message" aria-hidden="true">
        <div class="modal-dialog" style="margin-bottom: 150px;" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="" style="">
                        <h4 class="modal-title h4" style="margin: 0 auto !important;"></h4>
                    </div>
                </div>
                <div class="modal-body">
                    <div class="row mb-2 text-start">
                        <div class="col text-muted" style="font-size:14px;">
                            {{DeliveryTermsViewing}}
                        </div>
                    </div>
                    <hr style="margin-bottom:5px;margin-top:5px;" />

                    <div class="row mb-5">
                        <div class="col-12" style="padding-right:0;">
                            <div class="d-grid gap-0">
                                <button @click="HideCourierTerms" type="button" class="btn btn-sm btn-light shadow btn-block" style="border-radius:0;">Done</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>





</template>

<script>
    import EventHub from '/src/Util/EventHub.js';
    import axios from '/src/components/NovaAxios.js';
    import { computed, ref, nextTick } from 'vue'
    import { toast } from 'vue3-toastify';

    import { useEditorStore } from '/src/stores/EditorStore';


    export default {
        inheritAttrs: false,
        name: 'CheckoutPayment',
        mixins: [],
        props: [],
        emits: ['update:modelValue'],

        components: {
        },
        computed:
        {            
            TotalPriceAfterTax: function () {
                var amt = (+this.Store.Checkout.Cart.Price) + this.TaxAmount;
                return this.FormatAsMoney(amt);
            },
            TaxAmount: function () {
                var taxRate = 0;
                switch (this.Store.Checkout.Cart.SelectedService) {
                    case "FieldNotarization":
                        taxRate = this.Store.TenantConfig.serviceConfigMobileNotary.taxRate;
                        break;
                    case "CourierDelivery":
                        taxRate = this.Store.TenantConfig.serviceConfigCourier.taxRate;
                        break;
                    case "Apostille":
                        taxRate = this.Store.TenantConfig.serviceConfigApostille.taxRate;
                        break;
                    case "FieldInspection":
                        taxRate = this.Store.TenantConfig.serviceConfigFieldInspection.taxRate;
                        break;
                    case "RONNotarization":
                        taxRate = this.Store.TenantConfig.serviceConfigNotary.taxRate;
                        break;
                }

                if (taxRate > 0) {
                    const tax = this.Store.Checkout.Cart.Price * (taxRate / 100);
                    return this.roundToMoney(tax);
                }
                return 0;
            },
            HaveExpressCourierItems: function () {
                return this.Store.Checkout.Cart.DeliveryItemInfo.some(item => item.Express == true);
            },
            HaveStandardCourierItems: function () {
                return this.Store.Checkout.Cart.DeliveryItemInfo.some(item => item.Express == false);
            },
            AppointmentDetails() {
                if (!this.Store.Checkout.Cart.ChosenAppointmentSlot) {
                    return 'Appointment not selected';
                }

                const { StartTime, EndTime } = this.Store.Checkout.Cart.ChosenAppointmentSlot;

                // Convert StartTime and EndTime to Date objects
                const startDate = new Date(StartTime);
                const endDate = new Date(EndTime);

                // Get human-readable weekday name
                const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
                const weekdayName = weekdays[startDate.getDay()];

                // Format date
                const date = startDate.toLocaleDateString();

                // Format time
                const startTime = startDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
                const endTime = endDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

                // Calculate duration
                const durationMs = endDate - startDate;
                const durationHours = durationMs / (1000 * 60 * 60);
                const durationMinutes = (durationHours - Math.floor(durationHours)) * 60;
                const durationString = durationHours >= 1
                    ? `${Math.floor(durationHours)} hour${Math.floor(durationHours) > 1 ? 's' : ''}`
                    : `${durationMinutes} minute${durationMinutes > 1 ? 's' : ''}`;

                // Construct the string
                const appointmentString = `${weekdayName}, ${date}, from ${startTime} to ${endTime}, duration ${durationString}`;

                return appointmentString;
            }
        },
        data() {
            return {  
                AfterOrderCompleteUrl: '',
                WasInstantRONOrder: false,
                Store: {},
                IntentStatus: '',
                ClientSecret: '',
                PaymentError: '',
                PaymentSubmitting: false,
                StripeFormClearToSubmit: false,
                StripeFormLoaded: false,
                StripeElements: null,
                StripeApi: null,  
                DeliveryTermsViewing: '',   
                StripeAmount: 0,
                UiAmount: '',
            };
        },
        watch: {
            'Store.Checkout.Cart.CurrentStep': function (newVal, oldVal) {                
                if (newVal != 3) {
                    return;
                }

                nextTick().then(() => {
                    this.LoadStripeUI(_SK);

                });
                
            }
        },
        methods:
        {
            roundToMoney(input, minimum = 0.00) {
                // Multiply by 100, use Math.ceil to round up, then divide by 100
                const rounded = Math.ceil(input * 100) / 100;
                return Math.max(rounded, minimum);
            },
            FormatApostilleRetAddr(apostilleReturn) {
                if (!apostilleReturn || !apostilleReturn.Name) {
                    return '<div>No address provided</div>';
                }

                const { Name, Street1, Street2, City, State, Zip, Country } = apostilleReturn;

                // Construct the address with conditional rendering for optional fields
                return `
                  <div>
                    <strong>${Name}</strong><br>
                    ${Street1 ? `${Street1}<br>` : ''}
                    ${Street2 ? `${Street2}<br>` : ''}
                    ${City || State || Zip ? `${City ? City + ', ' : ''}${State ? State + ' ' : ''}${Zip || ''}<br>` : ''}
                    ${Country ? `${Country}` : ''}
                  </div>
                `;
            },
            FormatCourierAddress(item) {
                if (!item) return 'No address provided';

                const parsed = this.ParseCourierInstructionPayload(item.Instructions);
                if (parsed && parsed.addressParts.length) {
                    const addressParts = parsed.addressParts;
                    const street1 = addressParts[1] || '';
                    const street2 = addressParts[2] || '';
                    const city = addressParts[3] || '';
                    const state = addressParts[4] || '';
                    const zip = addressParts[5] || '';

                    const segments = [];
                    if (street1) segments.push(street1);
                    if (street2) segments.push(street2);

                    const cityState = [city, state].filter(Boolean).join(', ');
                    const cityStateZip = [cityState, zip].filter(Boolean).join(' ').trim();
                    if (cityStateZip) {
                        segments.push(cityStateZip);
                    }

                    if (segments.length) {
                        return segments.join(', ');
                    }
                }

                return item.Address || 'No address provided';
            },
            FormatCourierRecipient(item) {
                if (!item) {
                    return '';
                }

                if (item.RecipientName) {
                    return item.RecipientName.trim();
                }

                const parsed = this.ParseCourierInstructionPayload(item.Instructions);
                return parsed?.addressParts?.[0]?.trim() || '';
            },
            FormatCourierInstructions(instructions) {
                if (!instructions) {
                    return '';
                }

                const strVal = instructions.toString();
                const parsed = this.ParseCourierInstructionPayload(strVal);
                if (!parsed) {
                    return strVal.trim();
                }

                return parsed.userInstructions;
            },
            ParseCourierInstructionPayload(raw) {
                if (!raw || typeof raw !== 'string') {
                    return null;
                }

                const addrMarker = 'ADDR_DATA:';
                if (!raw.includes(addrMarker)) {
                    return null;
                }

                const userInstMarker = '||USER_INST:';
                const payloadStart = raw.indexOf(addrMarker) + addrMarker.length;
                const payloadEnd = raw.includes(userInstMarker) ? raw.indexOf(userInstMarker) : raw.length;
                const addressSegment = raw.substring(payloadStart, payloadEnd);
                const addressParts = addressSegment.split('|').map(part => (part || '').trim());

                let userInstructions = '';
                if (raw.includes(userInstMarker)) {
                    userInstructions = raw.substring(raw.indexOf(userInstMarker) + userInstMarker.length).trim();
                }

                return {
                    addressParts,
                    userInstructions
                };
            },
            GetBaseUrl: function() {
                var baseUrl = window.location.origin;
                if (!baseUrl.endsWith('/')) {
                    baseUrl += '/';
                }
                return baseUrl;
            },
            HideCourierTerms: function () {
                var modal = bootstrap.Modal.getOrCreateInstance('#MessageModalCourierTerms');
                if (modal) {
                    modal.hide();
                }
            },
            ViewCourierTerms: function (terms) {
                this.DeliveryTermsViewing = terms;
                var modal = bootstrap.Modal.getOrCreateInstance('#MessageModalCourierTerms');
                if (modal) {
                    modal.show();
                }
            },
            ShowCheckoutComplete: function () {
                var modal = bootstrap.Modal.getOrCreateInstance('#OrderCompleteModal');
                if (modal) {
                    modal.show();
                }
            },
            FormatDate(jsDate) {
                if (!this.Store.Checkout.Cart.ChosenAppointmentSlot) {
                    return 'Appointment not selected';
                }

                const { StartTime, EndTime } = this.Store.Checkout.Cart.ChosenAppointmentSlot;

                // Convert StartTime and EndTime to Date objects
                const startDate = new Date(StartTime);
                const endDate = new Date(EndTime);

                // Get human-readable weekday name
                const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
                const weekdayName = weekdays[startDate.getDay()];

                // Format date
                const date = startDate.toLocaleDateString();

                // Format time
                const startTime = startDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
                const endTime = endDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

                // Calculate duration
                const durationMs = endDate - startDate;
                const durationHours = durationMs / (1000 * 60 * 60);
                const durationMinutes = (durationHours - Math.floor(durationHours)) * 60;
                const durationString = durationHours >= 1
                    ? `${Math.floor(durationHours)} hour${Math.floor(durationHours) > 1 ? 's' : ''}`
                    : `${durationMinutes} minute${durationMinutes > 1 ? 's' : ''}`;

                // Construct the string
                const appointmentString = `${weekdayName}, ${date}, at ${startTime}`;

                return appointmentString;
            },
            FormatAsMoney(number) {
                // Convert to number if it's in string format or if it's falsy
                const num = (typeof number === 'string' || !number) ? parseFloat(number) : number;

                // Check if the conversion to number was successful or if it's still falsy
                if (isNaN(num) || !num) {
                    return "TBD";
                }

                // Format as USD currency
                return num.toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD'
                });
            },
            async OnPaymentSubmit() {
                //if (!this.PaymentIntent || !this.PaymentIntent.clientSecret) {
                //    toast.error("Unable to submit payment method. Please refresh page and try again.");
                //    return;
                //}
                //var that = this;

                EventHub.$emit("PageLoading", true);

                // Trigger form validation and wallet collection
                const { error: submitError } = await this.StripeElements.submit();
                if (submitError) {
                    toast.error(submitError.message);
                    this.PaymentError = submitError.message;
                    EventHub.$emit("PageLoading", false);
                    return;
                }

                this.PaymentError = null;

                // Create the ConfirmationToken using the details collected by the Payment Element
                // and additional shipping information
                const { error, confirmationToken } = await this.StripeApi.createConfirmationToken({
                    elements: this.StripeElements,
                    params: {
                        return_url: this.GetBaseUrl()
                    }
                });

                if (error) {
                    // This point is only reached if there's an immediate error when
                    // creating the ConfirmationToken. Show the error to customer (for example, payment details incomplete)
                    EventHub.$emit("PageLoading", false);
                    toast.error("There was an error." + (error ? error.message : ""));
                    return;
                }

                var that = this;

                var token = document.querySelectorAll('input[name=__RequestVerificationToken]')[0].value;

                var cart = { ...this.Store.Checkout.Cart };

                axios.postForm('/API/CheckoutCreateConfirmIntent', {
                    cache: false,
                    cart: cart,
                    uiamount: this.UiAmount,
                    stripeamount: this.StripeAmount,
                    confirmtoken: confirmationToken.id
                }, {
                    maxRedirects: 0,
                    cache: false,
                    headers: {
                        'RequestVerificationToken': token
                    }
                }).then(async function (response) {                   
                    if (response.request.responseURL.toLowerCase().indexOf("account") > -1) {
                        toast.error("Session expired. Redirecting to login...");
                        location.href = response.request.responseURL;
                        return;
                    }

                    if (response.data.success) {
                        that.IntentStatus = response.data.intentstatus;
                        that.ClientSecret = response.data.clientsecret;

                        if (response.data.intentstatus === "requires_action") {
                            // Use Stripe.js to handle the required next action
                            const {
                                herror,
                                paymentIntent
                            } = await that.StripeApi.handleNextAction({
                                clientSecret: response.data.clientsecret
                            });

                            if (herror)
                            {
                                // Show error from Stripe.js in payment form
                                this.PaymentError = herror.message;
                                toast.error("Error submitting payment. " + herror.message);                                
                            }
                            else
                            {
                                toast.success("Order Complete.");
                                // Actions handled, show success message
                            }
                        }
                        else
                        {
                            if (response.data.ordercomplete) {
                                // If it's a express notarization service with service speed == 1, then show a special message
                                if (that.Store.Checkout.Cart.SelectedService == 'RONNotarization' && that.Store.Checkout.Cart.ServiceSpeed == 1)
                                {
                                    toast.success("Order Complete. Please proceed to the online meeting room now.");
                                }
                                else {
                                    toast.success("Order Complete. Thank you for your business! We have emailed a receipt to your inbox!");
                                }    
                                debugger;
                                that.WasInstantRONOrder = response.data.wasinstantronorder;
                                that.AfterOrderCompleteUrl = response.data.afterordercompleteurl;
                                that.ShowCheckoutComplete();
                            }
                            else {
                                toast.success("Please Refresh The Page.");
                            }    

                            that.Store.CheckoutHideUI = true;
                        }
                       
                        //intentstatus = paymentIntent.Status,
                        //intentid = paymentIntent.Id

                        EventHub.$emit("PageLoading", false);
                    }
                    else {
                        EventHub.$emit("PageLoading", false);
                        toast.error("There was an error checking out. Your payment was not charged. " + response.data.msg);
                    }
                }).catch(function (error) {
                    EventHub.$emit("PageLoading", false);
                    toast.error("There was an error. Please refresh the page and try again. " + (error ? error : ""));
                });

                //
                //elements: this.StripeElements,
                //    clientSecret: this.PaymentIntent.clientSecret,
                //        redirect: 'if_required',
                //            confirmParams: {
                //    return_url: 'https://admin.notarylaunchpad.com/home/subscription'
                //}


            },

            LoadStripeUI(clientSecret) {
                // Check if all required objects and properties are defined and valid
                var amt = 0;
                if (
                    this.Store &&
                    this.Store.Checkout &&
                    this.Store.Checkout.Cart &&
                    this.TotalPriceAfterTax
                ) {
                    // Format the price and remove the dollar sign, then trim any whitespace
                    var formattedPrice = this.TotalPriceAfterTax;
                    this.UiAmount = formattedPrice;
                    amt = +formattedPrice.replace("$", "").replace(",", "").replace(" ", "").trim();
                } else {
                    console.error("Invalid structure or properties.");
                    this.UiAmount = '';
                    amt = 0; // Set amt to null or handle the error as needed
                }

                amt *= 100;
                amt = Math.round(amt);
                this.StripeAmount = amt || 0;
                var mode = 'payment';
                const options = {                    
                    mode: mode,
                    currency: 'usd',
                    paymentMethodCreation: 'manual',
                    // Fully customizable with appearance API.
                    appearance: {/*...*/ },
                };

                if (mode == 'payment') {
                    options.amount = amt;
                }

                if (this.Store.Checkout.Cart.SelectedService == 'RONNotarization')
                {
                    options.setupFutureUsage = 'off_session';
                }

                // Set up Stripe.js and Elements using the SetupIntent's client secret
                this.StripeElements = this.StripeApi.elements(options);

                // Create and mount the Payment Element
                const paymentElement = this.StripeElements.create('payment');
                paymentElement.mount('#payment-element');

                var that = this;
                paymentElement.on('ready', () => { that.StripeFormLoaded = true; });
                paymentElement.on('change', (event) => {
                    that.StripeFormClearToSubmit = event.complete;
                });
            },

            OnCmdNext: async function () {
                if (this.Store.Checkout.Cart.CurrentStep != 3) {
                    return;
                }

                this.StartError = '';
            },

            OnStepActivated: function () {
               
            }
        },
        created() {            
            this.Store  = useEditorStore(); 
            this.StripeApi = Stripe(_SK, {stripeAccount: this.Store.Checkout.Cart.StoreId });
            EventHub.$on('OnCmdNext', this.OnCmdNext);
            EventHub.$on('OnStepActivated', this.OnStepActivated);
        },
        beforeUnmount() {
            EventHub.$off('OnCmdNext', this.OnCmdNext);
            EventHub.$off('OnStepActivated', this.OnStepActivated);
        },
        mounted() {
            
            this.Store.IsLoggedInRouter(null, () => {
                location.href = '/Account/Login?ReturnUrl=%2FContent%2FCheckout'
                return;
            });
            nextTick().then(() => {
                
            });
        },
        activated() {
            alert("act");
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
   
</style>

